import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/giris");
      return;
    }
    const session_id = m[1];
    // Clear hash from URL
    window.history.replaceState({}, "", window.location.pathname);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Also store session_token as bearer fallback
        if (data.session_token) localStorage.setItem("ks_token", data.session_token);
        setUser(data.user);
        nav("/panelim");
      } catch (e) {
        nav("/giris");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="auth-callback">
      <p className="text-sm text-stone-500">Google oturumu doğrulanıyor…</p>
    </div>
  );
}
